import React, { useState } from 'react';
import Description from './Description';
import Budget from './Budget';

const TabsSection = ({
  campaignData,
  handlePaymentClick,
  recurrence,
  setRecurrence,
}) => {
  const [tab, setTab] = useState(0);
  return (
    <div className='tab-section'>
      <div className='tabs'>
        <div className='tab-control'>
          <nav>
            <button
              className={`${tab === 0 ? 'active' : ''}`}
              onClick={() => setTab(0)}>
              Descripción
            </button>
            <button
              className={`${tab === 1 ? 'active' : ''}`}
              onClick={() => setTab(1)}>
              Presupuesto
            </button>
            <button
              className={`${tab === 2 ? 'active' : ''}`}
              onClick={() => setTab(2)}>
              Avances
            </button>
          </nav>
        </div>
      </div>
      {tab === 0 && <Description campaignData={campaignData} />}
      {tab === 1 && <Budget Budget={campaignData.budget} />}
      {tab === 2 && <h2>Aun no hay avances para mostrar</h2>}
    </div>
  );
};
export default TabsSection;
